'use strict';

module.exports = require('./components/DocEditor/Block').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/Block.js
// module id = 1904
// module chunks = 0